/**
 * @description: 商品盈利汇总报表
 * @author: lyr
*/
<template>
    <div class="profit-total-report">
        <div class="red-tip">注：当天营业数据就只能单个营业日</div>
        <div class="list">
            <el-form :inline="true" size="small" :model="list_form">
                <el-form-item label="时间">
                    <div class="clearfix" ref="list_date">
                        <el-col :span="11">
                            <el-input placeholder="开始时间" v-model="list_form.start_time"></el-input>
                        </el-col>
                        <el-col class="el-line" :span="2">-</el-col>
                        <el-col :span="11">
                            <el-input placeholder="结束时间" v-model="list_form.end_time"></el-input>
                        </el-col>
                    </div>
                </el-form-item>
                <el-form-item label="门店">
                    <el-select v-model="list_form.shop_id" filterable  placeholder="请选择门店" @change="changeShop">
                        <el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="商品类型">
                    <el-input placeholder="请选择商品类型" 
                    v-model="goods_type_str" 
                    readonly
                    @click.native="openGoodsTypePop"></el-input>
                </el-form-item>
                <el-form-item label="商品名称">
                    <el-input v-model="list_form.goods_name" clearable placeholder="请输入商品名称"></el-input>
                </el-form-item>
                <el-form-item label="销售类型">
                    <el-input placeholder="请选择商品类型" v-model="info_type_str" readonly @click.native="openInfoTypePop"></el-input>
                </el-form-item>
                <el-form-item label="价格策略">
                    <el-select v-model="list_form.bill_goods_price_rule_id" filterable  placeholder="请选择价格策略">
                        <el-option v-for="item in bill_price_rule_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button :type="list_form.group_by=='1'?'primary':''" @click="onGroupByBtnClick(1)">按商品统计</el-button>
                    <el-button :type="list_form.group_by=='2'?'primary':''" @click="onGroupByBtnClick(2)">按出货仓库统计</el-button>
                    <el-button :type="list_form.group_by=='3'?'primary':''" @click="onGroupByBtnClick(3)">按区域统计</el-button>
                    <el-button :type="list_form.group_by=='4'?'primary':''" @click="onGroupByBtnClick(4)">按商品类型统计</el-button>
                    <el-button :type="list_form.group_by=='5'?'primary':''" @click="onGroupByBtnClick(5)">按销售类型统计</el-button>
                    <el-button type="primary" @click="listQuery">查询</el-button>
                    <el-button @click="checkExport">导出</el-button>
                </el-form-item>
            </el-form>
            <div class="total-row">
                <div class="item">折后总额：{{actual_total}}</div>
                <div class="item">成本总额：{{buying_price_total}}</div>
                <div class="item">利润总额：{{profit_price_total}}</div>
            </div>
            <el-table
                v-loading="loading"
                element-loading-text="努力加载中，请稍后..."
                element-loading-background="rgba(0, 0, 0, 0.6)"
                :header-cell-style="{'text-align':'center'}"
                :cell-style="{'text-align':'center'}"
                :data="list_table">
                <el-table-column :prop="item.prop" :label="item.name" v-for="item in table_column"></el-table-column>
            </el-table>
            <el-pagination
                background
                layout="total, prev, pager, next, jumper"
                :page-size="GLOBAL.PAGESIZE"
                :current-page.sync="list_page"
                :total="list_total"
                @current-change="getList">
            </el-pagination>
        </div>
        <!-- 商品类型选择 -->
        <div class="goods-type-pop" ref="goods_type_pop">
            <div class="checkbox-wrapper">
                <el-checkbox v-model="checkAllGoodsType" @change="handleCheckAllGoodsTypeChange">全选</el-checkbox>
                <el-checkbox-group v-model="list_form.goods_type" @change="handleCheckGoodsTypeChange">
                    <el-checkbox v-for="item in goods_type_list" :label="item.id" :key="item.id">{{item.name}}</el-checkbox>
                </el-checkbox-group>
            </div> 
        </div>
         <!-- 销售类型选择 -->
        <div class="info-type-pop" ref="info_type_pop">
            <div class="checkbox-wrapper">
                <el-checkbox v-model="checkAllInfoType" @change="handleCheckAllInfoTypeChange">全选</el-checkbox>
                <el-checkbox-group v-model="list_form.info_type" @change="handleCheckInfoTypeChange">
                    <el-checkbox v-for="item in info_type_list" :label="item.id" :key="item.id">{{item.name}}（{{item.remark}}）</el-checkbox>
                </el-checkbox-group>
            </div> 
        </div>
        <!-- 预约导出弹窗 -->
        <div class="book-export-pop ele-hide" ref="book_export_pop">
            <div class="red-tip">由于当前导出数据量较大，您需操作预约导出，操作预约导出后，需等待系统生成数据，数据生成完成后可在历史预约中下载查看！数据生成过程中可以关闭当前窗口，可再次操作“导出”进入查看导出进度。</div>
            <div class="pop-row center">
                <el-button type="primary" @click="doBookExport">预约导出</el-button>
                <el-button @click="cancelExport">取消</el-button>
            </div>
            <div class="row-tip">历史预约（注：历史预约仅显示该登录账号最近一次预约操作数据）</div>
            <div class="pop-row bottom" v-if="book_export_log_list.length>0">
                <div class="time">{{book_export_log_list[0].create_time}}</div>
                <div class="right">
                    <span class="status">{{book_export_log_list[0].status_name}}</span>
                    <el-button type="primary" :disabled="book_export_log_list[0].status==0" @click="downloadFile">下载</el-button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: 'profit-total-report',
        data() {
            return {
                loading: false,
                shop_list: [],
                goods_type_list: [],
                info_type_list: [{
                    id: '1',
                    name: '仅单品销售',
                    remark: '不含商品套餐/开房套餐内商品'
                }, {
                    id: '2',
                    name: '仅套餐销售内商品',
                    remark: '不含赠送的套餐内商品'
                }, {
                    id: '3',
                    name: '仅赠送',
                    remark: '包含赠送单品和赠送套餐内商品'
                }],
                checkAllGoodsType: false,
                checkAllInfoType: false,
                list_form: {
                    start_time: '',
                    end_time: '',
                    shop_id: '',
                    goods_type: [],
                    goods_name: '',
                    info_type: [], //销售类型 1仅单品销售 2仅套餐销售内商品 3仅赠送
                    group_by: '1', //1按商品统计 2按出货仓统计 3按区域统计 4按商品类型统计 5按销售类型
                    bill_goods_price_rule_id: '',
				},
				list_table: [],
				list_page: 1,
                list_total: 0,
                actual_total: 0, // 折后总额
                buying_price_total: 0, // 成本总额
                profit_price_total: 0, // 利润总额
                bill_price_rule_list: [], // 账单价格策略列表
                book_export_log_list: [], // 历史预约
            }
        },
        computed: {
            goods_type_str() {
                if (this.list_form.goods_type.length == 0) {
                    return ''
                }else if(this.list_form.goods_type.length == this.goods_type_list.length) {
                    return '全部'
                }else {
                    let res = []
                    this.list_form.goods_type.forEach(v => {
                        this.goods_type_list.forEach(item => {
                            if (item.id == v) {
                                res.push(item.name)
                            }
                        })
                    })
                    return res.join(',')
                }
            },

            info_type_str() {
                if (this.list_form.info_type.length == 0) {
                    return ''
                }else if(this.list_form.info_type.length == this.info_type_list.length) {
                    return '全部'
                }else {
                    let res = []
                    this.list_form.info_type.forEach(v => {
                        this.info_type_list.forEach(item => {
                            if (item.id == v) {
                                res.push(item.name)
                            }
                        })
                    })
                    return res.join(',')
                }
            },

            table_column() {
                let res = []
                let base = [{
                        name: '商品类型',
                        prop: 'goods_type_name'
                    }, {
                        name: '商品名称',
                        prop: 'goods_name'
                    }, {
                        name: '单位',
                        prop: 'goods_unit_name'
                    }, {
                        name: '单价',
                        prop: 'price'
                    }, {
                        name: '净销售数量',
                        prop: 'quantity'
                    }, {
                        name: '折后单价',
                        prop: 'actual'
                    }, {
                        name: '折后总额',
                        prop: 'actual_total'
                    }, {
                        name: '成本单价',
                        prop: 'buying_price'
                    }, {
                        name: '成本总额',
                        prop: 'buying_price_total'
                    }, {
                        name: '利润总额',
                        prop: 'profit_price_total'
                    }, {
                        name: '利润率',
                        prop: 'profit_margin'
                    }]
                if (this.list_form.group_by == '1') {// 按商品统计
                    console.log(1)
                    res = base
                }else if (this.list_form.group_by == '2') {// 按出货仓统计
                    let obj = [{
                        name: '出货仓库',
                        prop: 'store_name'
                    }]
                    res = obj.concat(base)
                }else if (this.list_form.group_by == '3') {// 按区域统计
                    let obj = [{
                        name: '区域',
                        prop: 'room_area_name'
                    }]
                    res = obj.concat(base)
                }else if (this.list_form.group_by == '4') {// 按商品类型统计
                    res = [{
                        name: '商品类型',
                        prop: 'goods_type_name'
                    }, {
                        name: '折后总额',
                        prop: 'actual_total'
                    }, {
                        name: '成本总额',
                        prop: 'buying_price_total'
                    }, {
                        name: '利润总额',
                        prop: 'profit_price_total'
                    }, {
                        name: '利润率',
                        prop: 'profit_margin'
                    }]
                }else if (this.list_form.group_by == '5') {// 按销售类型统计
                    res = [{
                        name: '商品类型',
                        prop: 'goods_type_name'
                    }, {
                        name: '商品名称',
                        prop: 'goods_name'
                    }, {
                        name: '单位',
                        prop: 'goods_unit_name'
                    }, {
                        name: '单价',
                        prop: 'price'
                    },{
                        name: '单品销售数量',
                        prop: 'item_quantity'
                    }, {
                        name: '套餐内销售数量',
                        prop: 'package_quantity'
                    }, {
                        name: '赠送数量',
                        prop: 'give_quantity'
                    }, {
                        name: '销售总数量',
                        prop: 'quantity'
                    }, {
                        name: '单品销售折后金额',
                        prop: 'item_actual_total'
                    }, {
                        name: '套餐内销售折后金额',
                        prop: 'package_actual_total'
                    }, {
                        name: '折后总额',
                        prop: 'actual_total'
                    }, {
                        name: '成本单价',
                        prop: 'buying_price'
                    }, {
                        name: '成本总额',
                        prop: 'buying_price_total'
                    }, {
                        name: '利润总额',
                        prop: 'profit_price_total'
                    }, {
                        name: '利润率',
                        prop: 'profit_margin'
                    }]
                }
                return res
            },
        },
        mounted: function() {
            // 日期
            this.list_form.start_time = moment().format('YYYY-MM-DD 08:00');
            this.list_form.end_time = moment().add(1, 'day').format('YYYY-MM-DD 08:00');
            this.innitDate();
            new Promise(resolve => {
                this.getShop(resolve)
            }).then(res => {
                this.list_form.shop_id = this.shop_list[0].id;
                this.getGoodsType()
                this.getBillPriceRule(this.list_form.shop_id)
                this.getList(1);
            })
        },
        methods: {
            // 初始化日期插件
            innitDate: function() {
                const _this = this;
                $(_this.$refs.list_date).daterangepicker({
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().toDate(),
                    endDate: moment().add(1, 'day').toDate(),
                }, function(start, end, label) {
                    _this.list_form.start_time = start.format('YYYY-MM-DD 08:00');
                    _this.list_form.end_time = end.format('YYYY-MM-DD 08:00');
                });
            },
            // 初始化门店输入框
            getShop: function(resolve) {
                const _this = this;

                Vue.axios.post('PublicData/api_getShopListByPurview', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {}
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.shop_list = res.data.response.result;
                        _this.shop_list.shift();
                        resolve()
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },

            changeShop(val) {
                this.list_form.shop_id = val
                if (!!val) {
                    this.getBillPriceRule(val)
                }
            },

            // 获取商品类型
            getGoodsType: function() {
                const _this = this;

                Vue.axios.post('PublicData/api_getGoodsType', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {}
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.goods_type_list = res.data.response.result.data
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },

            // 获取账单价格策略列表
            getBillPriceRule: function(shop_id) {
                const _this = this;
                Vue.axios.post('PublicData/api_getBillGoodsPriceRule', {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.bill_price_rule_list = res.data.response.result;
                        _this.bill_price_rule_list.unshift({
                            id: '',
                            name: '全部'
                        })
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },
           
            getList(page) {
				const _this = this;

				_this.loading = true;
				Vue.axios.post('Report/getGoodsSalesSumList', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": page,
							"page_size": _this.GLOBAL.PAGESIZE,
                            "start_date": _this.list_form.start_time,
                            "end_date": _this.list_form.end_time,
							"shop_id": _this.list_form.shop_id,
                            "goods_type": _this.list_form.goods_type,
                            "goods_name": _this.list_form.goods_name,
                            "info_type": _this.list_form.info_type, //销售类型 1仅单品销售 2仅套餐销售内商品 3仅赠送
                            "group_by": _this.list_form.group_by,
                            "bill_goods_price_rule_id": _this.list_form.bill_goods_price_rule_id,
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
							_this.list_total = Number(res.data.response.result.total)
                            _this.actual_total = res.data.response.result.actual_total
                            _this.buying_price_total = res.data.response.result.buying_price_total
                            _this.profit_price_total = res.data.response.result.profit_price_total
						}
						_this.list_table = res.data.response.result.rows;
						_this.loading = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
			},

            // 打开商品类型选择弹窗
            openGoodsTypePop() {
                let _this = this
                let c_goods_type = _this.list_form.goods_type
                layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['选择商品类型', true],
                    area: ['550px', ''], // 宽高
                    content: $(_this.$refs.goods_type_pop),
                    cancel: function() {
                        _this.list_form.goods_type = c_goods_type
                    }
                }, function() {
                    layer.closeAll()
                }, function() {
                    _this.list_form.goods_type = c_goods_type
                    layer.closeAll()
                });
            },

            // 商品类型全选
            handleCheckAllGoodsTypeChange(val) {
                this.list_form.goods_type = []
                this.checkAllGoodsType = val
                if (val) {
                    this.goods_type_list.forEach(item => {
                        this.list_form.goods_type.push(item.id)
                    })
                }
            },

            // 选择商品类型
            handleCheckGoodsTypeChange(val) {
                this.checkAllGoodsType = val.length === this.goods_type_list.length
            },

            // 打开销售类型选择弹窗
            openInfoTypePop() {
                let _this = this
                let c_info_type = _this.list_form.info_type
                layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['选择销售类型', true],
                    area: ['500px', '300px'], // 宽高
                    content: $(_this.$refs.info_type_pop),
                    cancel: function() {
                        _this.list_form.info_type = c_info_type
                    }
                }, function() {
                    layer.closeAll()
                }, function() {
                    _this.list_form.info_type = c_info_type
                    layer.closeAll()
                });
            },

            // 销售类型全选
            handleCheckAllInfoTypeChange(val) {
                this.list_form.info_type = []
                this.checkAllInfoType = val
                if (val) {
                    this.info_type_list.forEach(item => {
                        this.list_form.info_type.push(item.id)
                    })
                }
            },

            // 选择销售类型
            handleCheckInfoTypeChange(val) {
                this.checkAllInfoType = val.length === this.info_type_list.length
            },

			// 查询
			listQuery() {
                this.list_page = 1
				this.getList(this.list_page);
            },

            // 点击统计方式按钮
            onGroupByBtnClick(group_by) {
                this.list_form.group_by = group_by
                this.list_page = 1
                this.getList(this.list_page)
            },

            // 检查导出状态
            checkExport() {
                let _this = this;
                Vue.axios.post('exportBook/exportCheck', {
                    "header": Vue.request_header,
                    "request": {
                        "type": 'goodsSalesSum' + _this.list_form.group_by,
                        "param": {
                            "page": _this.list_page,
                            "page_size": _this.GLOBAL.PAGESIZE,
                            "start_date": _this.list_form.start_time,
                            "end_date": _this.list_form.end_time,
                            "shop_id": _this.list_form.shop_id,
                            "goods_type": _this.list_form.goods_type,
                            "goods_name": _this.list_form.goods_name,
                            "info_type": _this.list_form.info_type, //销售类型 1仅单品销售 2仅套餐销售内商品 3仅赠送
                            "group_by": _this.list_form.group_by,
                            "bill_goods_price_rule_id": _this.list_form.bill_goods_price_rule_id,
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        layer.closeAll()
                        if (res.data.response.result.status == '1') { // 原逻辑直接导出
                            _this.listExport();
                        }else {
                            _this.book_export_log_list = res.data.response.result.log_list
                            // 预约导出弹窗
                            layer.confirm('', {
                                skin: 'public-alert-skin',
                                type: 1,
                                btn: [], // 按钮
                                title: ['导出提示', true],
                                area: ['700px', ''], // 宽高
                                content: $(_this.$refs.book_export_pop),
                                offset: '100px',
                            });
                        }

                    } else {
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
            },
            // 预约导出
            doBookExport() {
                let _this = this

                Vue.axios.post('exportBook/addExportBook', {
                    "header": Vue.request_header,
                    "request": {
                        "type": 'goodsSalesSum' + _this.list_form.group_by,
                        "param": {
                            "page": _this.list_page,
                            "page_size": _this.GLOBAL.PAGESIZE,
                            "start_date": _this.list_form.start_time,
                            "end_date": _this.list_form.end_time,
                            "shop_id": _this.list_form.shop_id,
                            "goods_type": _this.list_form.goods_type,
                            "goods_name": _this.list_form.goods_name,
                            "info_type": _this.list_form.info_type, //销售类型 1仅单品销售 2仅套餐销售内商品 3仅赠送
                            "group_by": _this.list_form.group_by,
                            "bill_goods_price_rule_id": _this.list_form.bill_goods_price_rule_id,
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.book_export_log_list = res.data.response.result.log_list
                    } else {
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
            },

            // 下载文件
            downloadFile() {
                // 已知文件的URL
                const fileUrl = this.book_export_log_list[0].file_url
                const fileName = "file.pdf"; // 自定义文件名

                // 创建一个隐藏的 <a> 元素
                const a = document.createElement("a");
                a.href = fileUrl;
                a.download = fileName;

                // 将 <a> 元素添加到页面中
                document.body.appendChild(a);

                // 触发点击事件，下载文件
                a.click();

                // 下载完成后移除该 <a> 元素
                document.body.removeChild(a);
            },

            cancelExport() {
                layer.closeAll()
            },
            
            listExport: function() {
                window.location.href = Vue.ctUrl + "Report/goodsSalesSumExport" +
                    "?start_date=" + this.list_form.start_time +
                    "&end_date=" + this.list_form.end_time +
                    "&shop_id=" + this.list_form.shop_id +
                    "&goods_type=" + this.list_form.goods_type +
                    "&info_type=" + this.list_form.info_type +
                    "&goods_name=" + this.list_form.goods_name + 
                    "&group_by=" + this.list_form.group_by +
                    "&bill_goods_price_rule_id=" + this.list_form.bill_goods_price_rule_id;
                layer.msg("导出成功！");
            },
        }
    }
</script>
<style lang="less" scoped>
    .red-tip {
        color: red;
        margin-bottom: 10px;
    }

    .total-row {
        margin-bottom: 10px;
        display: flex;
        flex-direction: row;
        align-items: center;
        .item {
            margin-right: 50px;
        }
    }

    .goods-type-pop,
    .info-type-pop {
        display: none;
        .el-checkbox {
            width: 150px;
            margin-bottom: 10px;
            margin-right: 10px;
        }
    }

    .info-type-pop {
        .el-checkbox {
            width: 320px;
        }
    }
    // 预约导出
    .book-export-pop {
        position: relative;
        .red-tip {
            color: red;
        }
        .pop-row {
            display: flex;
            flex-direction: row;
            align-items: center;
            &.center {
                margin: 30px 0 60px 0;
                justify-content: center;
            }
            &.bottom {
                position: absolute;
                left: 0;
                bottom: 0;
                width: 100%;
                padding: 0 35px;
                box-sizing: border-box;
                justify-content: space-between;
                .right {
                    .status {
                        margin-right: 10px;
                        color: #409EFF;
                    }
                }
            }
        }
        .row-tip {
            margin-bottom: 20px;
        }
        .el-button {
            width: 100px;
        }
    }
</style>